// // ===== AGB STORE MODULE =====
// // Manages all application state with event emission
// AGB.define('store', ['core'], function (Core) {
//     const { bus, scheduler, ErrorHandler } = Core;

//     // Single source of truth
//     const state = {
//         // Product data
//         product: null,

//         // Builder stages
//         builderStage: 0,

//         // Base configuration
//         baseItem: null,
//         commonVariantColor: { color: null },

//         // Accepted items
//         acceptedItems: [],

//         // Suggestions
//         suggestionQueue: [],
//         suggestionIndex: 0,
//         maxVisitedIndex: 0,
//         maxSuggestions: 10,
//         compatibleHandles: [],

//         // UI state
//         userInteractedOptions: new Set(),
//         proceededToStep2: false,
//         activeView: 'front',
//         pendingSuggestion: null,

//         // Internal
//         resolveVariantTimeout: null,
//         consumedHandles: new Set(),
//         seenSuggestions: new Set(),

//         // Cleanup tracking
//         eventListeners: new Set(),
//         timers: new Set()
//     };





//     // Dependency map for suggestions
//     const SUGGESTION_DEPENDENCIES = {
//         'pincer-2nd-layer-admin-pouch': ['pincer-placard'],
//         'agilite-sapi-hydration-bladder': ['micro-map'],
//         'general-purpose-pouch': ['warfighter-wings'],
//         'mag-release-dump-pouch': ['pincer-single-556-mag-pouch'],
//         'md2-compact-trauma-kit-contents': ['md2-compact-trauma-kit'],
//         'combat-application-tourniquet-c-a-t': ['tourniquet-holder']
//     };

//     const COLOR_FALLBACK_MAP = {
//         'Multicam': ['Coyote Tan', 'Coyote Brown', 'Ranger Green'],
//         'Multicam Black': ['Black', 'Ranger Green'],
//         'Ranger Green': ['Multicam', 'Black', 'Coyote Tan'],
//         'Black': ['Multicam Black', 'Ranger Green'],
//         'M81 Woodland': ['Multicam', 'Ranger Green'],
//         'Coyote Brown': ['Coyote Tan', 'Multicam'],
//         'Coyote Tan': ['Coyote Brown', 'Multicam'],
//     };

//     const SUGGESTION_GUARDS = {
//         'level-3st-ceramic-armor-plate-protector': ({ base, state, product }) => {
//             // Check if current product is a bundle using Bundles module
//             const currentHandle = product?.handle || state?.product?.handle;
//             let isBundle = false;

//             try {
//                 const Bundles = AGB?.require?.('bundles');
//                 if (currentHandle && Bundles?.isBundle) {
//                     isBundle = Bundles.isBundle(currentHandle);
//                 }
//             } catch (e) {
//                 // If Bundles module not available, fall through
//             }

//             if (isBundle) {
//                 return false; // Don't block plates in bundles
//             }

//             // For regular products, block if size is Large
//             return /\(Large\)/i.test(base?.size || '');
//         }
//     };

//     // Build reverse dependency map
//     const dependentsMap = (() => {
//         const out = Object.create(null);
//         for (const [child, parents] of Object.entries(SUGGESTION_DEPENDENCIES)) {
//             const list = Array.isArray(parents) ? parents : [parents];
//             list.forEach(p => {
//                 if (typeof p === 'string' && p) {
//                     (out[p] ||= []).push(child);
//                 }
//             });
//         }
//         return out;
//     })();

//     // State getters
//     function getState() {
//         return state;
//     }

//     // State mutations
//     function setBaseItem(item) {
//         state.baseItem = item;
//         window.baseItem = item; // Legacy support
//         bus.emit('baseItemChanged');
//         scheduler.mark('ui');
//         scheduler.mark('pricing');
//         scheduler.mark('canvas');

//         ErrorHandler.safeSync(() => {
//             if (window.DEBUG_LOGGER?.builderStarted) {
//                 window.DEBUG_LOGGER.builderStarted(item.color, item.size);
//             }
//         }, null, 'DEBUG_LOGGER.builderStarted');
//     }

//     function addAcceptedItem(item) {
//         state.acceptedItems.push(item);
//         window.acceptedItems = state.acceptedItems; // Legacy support
//         bus.emit('acceptedItemsChanged');
//         scheduler.mark('ui');
//         scheduler.mark('pricing');
//         scheduler.mark('canvas');
//         scheduler.mark('sticky');

//         ErrorHandler.safeSync(() => {
//             if (window.DEBUG_LOGGER?.addSuggestion) {
//                 window.DEBUG_LOGGER.addSuggestion(item.handle, (state.suggestionIndex + 1));
//             }
//         }, null, 'DEBUG_LOGGER.addSuggestion');
//     }

//     function removeAcceptedItem(index) {
//         const removed = state.acceptedItems.splice(index, 1)[0];
//         window.acceptedItems = state.acceptedItems;

//         // if (removed?.handle) {
//         //     // Remove dependent items (children)
//         //     const dependents = dependentsMap[removed.handle] || [];
//         //     dependents.forEach(depHandle => {
//         //         const depIdx = state.acceptedItems.findIndex(i => i.handle === depHandle);
//         //         if (depIdx > -1) {
//         //             const depRemoved = state.acceptedItems.splice(depIdx, 1)[0];
//         //             const parentName = Core.utils.displayName(removed);
//         //             const childName = Core.utils.displayName(depRemoved);
//         //             Core.utils.toast(
//         //                 `${parentName.substring(0, 20) + (parentName.length > 20 ? '...' : '')} was removed. ` +
//         //                 `Due to that - ${childName.substring(0, 20) + (childName.length > 20 ? '...' : '')} was removed also.`
//         //             );
//         //         }
//         //     });

//         //     // Also remove items that depend on this removed item (reverse dependencies)
//         //     Object.entries(SUGGESTION_DEPENDENCIES).forEach(([childHandle, parents]) => {
//         //         const parentList = Array.isArray(parents) ? parents : [parents];
//         //         if (parentList.includes(removed.handle)) {
//         //             const childIdx = state.acceptedItems.findIndex(i => i.handle === childHandle);
//         //             if (childIdx > -1) {
//         //                 state.acceptedItems.splice(childIdx, 1);
//         //                 const childName = Core.utils.displayName({ handle: childHandle });
//         //                 Core.utils.toast(`${childName} was removed (requires ${Core.utils.displayName(removed)})`);
//         //             }
//         //         }
//         //     });
//         // }

//         bus.emit('acceptedItemsChanged');
//         scheduler.mark('ui');
//         scheduler.mark('canvas');
//         scheduler.mark('sticky');
//         scheduler.mark('pricing');
//     }

//     function setActiveView(view) {
//         state.activeView = (view === 'back') ? 'back' : 'front';
//         scheduler.mark('canvas');
//     }

//     function clearAll() {
//         state.acceptedItems = [];
//         state.baseItem = null;
//         state.proceededToStep2 = false;
//         state.userInteractedOptions.clear();
//         state.suggestionQueue = [];
//         state.suggestionIndex = 0;
//         state.maxVisitedIndex = 0;
//         state.pendingSuggestion = null;
//         window.acceptedItems = state.acceptedItems;
//         window.baseItem = state.baseItem;
//         bus.emit('acceptedItemsChanged');
//         bus.emit('baseItemChanged');
//         document.documentElement.removeAttribute('data-agb-step2');
//     }

//     // Utility functions
//     function hasAccepted(handle) {
//         return Array.isArray(state.acceptedItems) &&
//             state.acceptedItems.some(i => i.handle === handle);
//     }

//     function getAcceptedIndex(handle) {
//         if (!Array.isArray(state.acceptedItems)) return -1;
//         return state.acceptedItems.findIndex(i => i.handle === handle);
//     }

//     function depsSatisfied(handle) {
//         const req = SUGGESTION_DEPENDENCIES[handle];

//         if (Array.isArray(req) && req.length) {
//             const ok = req.every(parent => typeof parent === 'string' && hasAccepted(parent));
//             if (!ok) return false;
//         } else if (typeof req === 'string') {
//             if (!hasAccepted(req)) return false;
//         }

//         const guard = SUGGESTION_GUARDS[handle];
//         if (typeof guard === 'function') {
//             const shouldBlock = !!guard({ state, base: state.baseItem, product: state.product });
//             if (shouldBlock) return false;
//         }

//         return true;
//     }

//     function countAcceptedQty(handle) {
//         if (!Array.isArray(state.acceptedItems)) return 0;
//         return state.acceptedItems.reduce((sum, it) =>
//             sum + (it.handle === handle ? Number(it.qty || 1) : 0), 0);
//     }

//     // Timer management
//     function addTimer(timerId) {
//         state.timers.add(timerId);
//         return timerId;
//     }

//     function addEventCleanup(cleanupFn) {
//         state.eventListeners.add(cleanupFn);
//         return cleanupFn;
//     }

//     function cleanup() {
//         // Clear all timeouts and intervals
//         state.timers.forEach(timer => {
//             clearTimeout(timer);
//             clearInterval(timer);
//         });
//         state.timers.clear();

//         // Remove event listeners
//         state.eventListeners.forEach(cleanupFn => {
//             ErrorHandler.safeSync(cleanupFn, null, 'event listener cleanup');
//         });
//         state.eventListeners.clear();

//         // Clear specific timeouts
//         if (state.resolveVariantTimeout) {
//             clearTimeout(state.resolveVariantTimeout);
//             state.resolveVariantTimeout = null;
//         }

//         // Cleanup completed
//     }

//     // Generic mutate function for complex operations
//     function mutate(fn) {
//         try {
//             fn(state);
//             // Auto-emit common events based on what changed
//             // (Could be made smarter with Proxy tracking)
//             scheduler.mark('ui');
//         } catch (e) {
//             // Silently fail in production
//         }
//     }

//     function setBuilderStage(stage) {
//         // Builder stage set
//         state.builderStage = stage;
//         scheduler.mark('ui');
//         scheduler.mark('canvas');
//         scheduler.mark('sticky');
//         scheduler.mark('pricing');
//     }

//     // Event subscription helpers
//     function on(event, callback) {
//         return bus.on(event, callback);
//     }

//     function emit(event, detail) {
//         bus.emit(event, detail);
//     }

//     // Store module ready

//     return {
//         // State access
//         getState,

//         // Builder stage
//         setBuilderStage,

//         // Specific mutations
//         setBaseItem,
//         addAcceptedItem,
//         removeAcceptedItem,
//         setActiveView,
//         clearAll,

//         // Generic mutation
//         mutate,

//         // Utilities
//         hasAccepted,
//         getAcceptedIndex,
//         depsSatisfied,
//         countAcceptedQty,

//         // Timer management
//         addTimer,
//         addEventCleanup,
//         cleanup,

//         // Events
//         on,
//         emit,

//         // Constants (exposed for other modules)
//         SUGGESTION_DEPENDENCIES,
//         SUGGESTION_GUARDS,
//         dependentsMap,
//         COLOR_FALLBACK_MAP
//     };
// });

// ===== AGB STORE MODULE =====
// Manages all application state with event emission
AGB.define('store', ['core', 'store-config'], function (Core, StoreConfig) {
    const { bus, scheduler, ErrorHandler } = Core;

    // Single source of truth
    const state = {
        // Product data
        product: null,

        // Builder stages
        builderStage: 0,

        // Base configuration
        baseItem: null,
        commonVariantColor: { color: null },

        // Accepted items
        acceptedItems: [],

        // Suggestions
        suggestionQueue: [],
        suggestionIndex: 0,
        maxVisitedIndex: 0,
        maxSuggestions: 10,
        compatibleHandles: [],

        // UI state
        userInteractedOptions: new Set(),
        proceededToStep2: false,
        activeView: 'front',
        pendingSuggestion: null,

        // Internal
        resolveVariantTimeout: null,
        consumedHandles: new Set(),
        seenSuggestions: new Set(),

        // Cleanup tracking
        eventListeners: new Set(),
        timers: new Set()
    };





    // Dependency map for suggestions (using US handles as source of truth)
    const SUGGESTION_DEPENDENCIES_US = {
        // Dorian 2026-07-13: trimmed to the ONLY real physical-mount dependency
        // (the SAPI bladder hangs on the micro-map). The original theme's other
        // pairs made the "*This item requires X" note appear on items that don't
        // actually mount on another, and gated the canvas needlessly. Removed.
        'agilite-sapi-hydration-bladder': ['micro-map']
        };

    // ── DYNAMIC config (product metafields → window.AGB_BUILDER_CONFIG) ──────────
    // See Related-Docs/gear-builder-dynamic-config.md. Each carrier renders its
    // accessories + each accessory's dependency rules into AGB_BUILDER_CONFIG.
    // Handles are already STORE-NATIVE (the metaobject references are THIS store's
    // products) → no US remap. Empty/unset → null → the hardcoded fallback above.
    function _readBuilderConfigIncluded() {
        try {
            const cfg = (typeof window !== 'undefined') && window.AGB_BUILDER_CONFIG;
            const inc = cfg && Array.isArray(cfg.included) ? cfg.included : null;
            return (inc && inc.length) ? inc : null;
        } catch (e) { return null; }
    }
    // { accessoryHandle: [parentHandles] } for deps flagged gate_layer (the
    // "don't render me until X is present" rule that drives the canvas gate +
    // depsSatisfied). Null when there's no dynamic config.
    function _dynamicDependenciesStoreNative() {
        const inc = _readBuilderConfigIncluded();
        if (!inc) return null;
        const out = {};
        let any = false;
        for (const acc of inc) {
            if (!acc || typeof acc.handle !== 'string' || !Array.isArray(acc.dependencies)) continue;
            const parents = acc.dependencies
                .filter(d => d && d.gate_layer !== false && typeof d.product === 'string' && d.product)
                .map(d => d.product);
            if (parents.length) { out[acc.handle] = parents; any = true; }
        }
        return any ? out : null;
    }
    // { accessoryHandle: [parentHandles] } for deps flagged co_activate (auto-add
    // the parent when the accessory is picked). EXPOSED for the staged co-activation
    // wiring in agb-suggest.js (doc §6); nothing consumes it yet.
    function _dynamicCoActivateStoreNative() {
        const inc = _readBuilderConfigIncluded();
        if (!inc) return {};
        const out = {};
        for (const acc of inc) {
            if (!acc || typeof acc.handle !== 'string' || !Array.isArray(acc.dependencies)) continue;
            const parents = acc.dependencies
                .filter(d => d && d.co_activate === true && typeof d.product === 'string' && d.product)
                .map(d => d.product);
            if (parents.length) out[acc.handle] = parents;
        }
        return out;
    }
    // Dorian 2026-07-13 — "for now disable ALL dependencies except the
    // micromap→SAPI-bladder pair": neutralize the metafield-driven
    // (gear_builder.dependencies) dependency overlay so it can't gate the canvas
    // or show "*This item requires X". Only the trimmed hardcoded map (the
    // single bladder→micro-map pair) remains active. Restore dynamic deps by
    // putting back `_dynamicDependenciesStoreNative()`.
    const _dynamicDeps = null; // was: _dynamicDependenciesStoreNative();
    const CO_ACTIVATE = _dynamicCoActivateStoreNative();

    // SUGGESTION_DEPENDENCIES (store-native; read by agb-suggest + the canvas gate)
    // = the mapped hardcoded fallback with the dynamic (store-native) deps overlaid,
    // so a populated metafield WINS per accessory and everything else stays baked.
    const SUGGESTION_DEPENDENCIES = Object.assign(
        StoreConfig.mapObjectKeys(
            Object.fromEntries(
                Object.entries(SUGGESTION_DEPENDENCIES_US).map(([key, deps]) => [
                    key,
                    StoreConfig.mapHandles(deps)
                ])
            )
        ),
        _dynamicDeps || {}
    );

    const COLOR_FALLBACK_MAP = {
        'Multicam': ['Coyote Tan', 'Coyote Brown', 'Ranger Green'],
        'Multicam Black': ['Black', 'Ranger Green'],
        'Ranger Green': ['Multicam', 'Black', 'Coyote Tan'],
        'Black': ['Multicam Black', 'Ranger Green'],
        'M81 Woodland': ['Multicam', 'Ranger Green'],
        'Coyote Brown': ['Coyote Tan', 'Multicam'],
        'Coyote Tan': ['Coyote Brown', 'Multicam'],
    };

    const SUGGESTION_GUARDS = {
        'level-3st-ceramic-armor-plate-protector': ({ base, state, product }) => {
            // Check if current product is a bundle using Bundles module
            const currentHandle = product?.handle || state?.product?.handle;
            let isBundle = false;

            try {
                const Bundles = AGB?.require?.('bundles');
                if (currentHandle && Bundles?.isBundle) {
                    isBundle = Bundles.isBundle(currentHandle);
                }
            } catch (e) {
                // If Bundles module not available, fall through
            }

            if (isBundle) {
                return false; // Don't block plates in bundles
            }

            // For regular products, block if size is Large
            return /\(Large\)/i.test(base?.size || '');
        }
    };

    // Build reverse dependency map
    const dependentsMap = (() => {
        const out = Object.create(null);
        for (const [child, parents] of Object.entries(SUGGESTION_DEPENDENCIES)) {
            const list = Array.isArray(parents) ? parents : [parents];
            list.forEach(p => {
                if (typeof p === 'string' && p) {
                    (out[p] ||= []).push(child);
                }
            });
        }
        return out;
    })();

    // State getters
    function getState() {
        return state;
    }

    // State mutations
    function setBaseItem(item) {
        state.baseItem = item;
        window.baseItem = item; // Legacy support
        bus.emit('baseItemChanged');
        scheduler.mark('ui');
        scheduler.mark('pricing');
        scheduler.mark('canvas');

        ErrorHandler.safeSync(() => {
            if (window.DEBUG_LOGGER?.builderStarted) {
                window.DEBUG_LOGGER.builderStarted(item.color, item.size);
            }
        }, null, 'DEBUG_LOGGER.builderStarted');
    }

    function addAcceptedItem(item) {
        state.acceptedItems.push(item);
        window.acceptedItems = state.acceptedItems; // Legacy support
        bus.emit('acceptedItemsChanged');
        scheduler.mark('ui');
        scheduler.mark('pricing');
        scheduler.mark('canvas');
        scheduler.mark('sticky');

        ErrorHandler.safeSync(() => {
            if (window.DEBUG_LOGGER?.addSuggestion) {
                // No position arg on purpose: state.suggestionIndex was NEVER
                // incremented (every event logged suggestion_number: 1 — bug fixed
                // 2026-07-13). The analytics module now resolves the REAL position
                // from the rendered card's data-suggestion-number by handle, which
                // is correct for both hardcoded and panel-driven suggestion lists.
                window.DEBUG_LOGGER.addSuggestion(item.handle);
            }
        }, null, 'DEBUG_LOGGER.addSuggestion');
    }

    function removeAcceptedItem(index) {
        const removed = state.acceptedItems.splice(index, 1)[0];
        window.acceptedItems = state.acceptedItems;

        // if (removed?.handle) {
        //     // Remove dependent items (children)
        //     const dependents = dependentsMap[removed.handle] || [];
        //     dependents.forEach(depHandle => {
        //         const depIdx = state.acceptedItems.findIndex(i => i.handle === depHandle);
        //         if (depIdx > -1) {
        //             const depRemoved = state.acceptedItems.splice(depIdx, 1)[0];
        //             const parentName = Core.utils.displayName(removed);
        //             const childName = Core.utils.displayName(depRemoved);
        //             Core.utils.toast(
        //                 `${parentName.substring(0, 20) + (parentName.length > 20 ? '...' : '')} was removed. ` +
        //                 `Due to that - ${childName.substring(0, 20) + (childName.length > 20 ? '...' : '')} was removed also.`
        //             );
        //         }
        //     });

        //     // Also remove items that depend on this removed item (reverse dependencies)
        //     Object.entries(SUGGESTION_DEPENDENCIES).forEach(([childHandle, parents]) => {
        //         const parentList = Array.isArray(parents) ? parents : [parents];
        //         if (parentList.includes(removed.handle)) {
        //             const childIdx = state.acceptedItems.findIndex(i => i.handle === childHandle);
        //             if (childIdx > -1) {
        //                 state.acceptedItems.splice(childIdx, 1);
        //                 const childName = Core.utils.displayName({ handle: childHandle });
        //                 Core.utils.toast(`${childName} was removed (requires ${Core.utils.displayName(removed)})`);
        //             }
        //         }
        //     });
        // }

        bus.emit('acceptedItemsChanged');
        scheduler.mark('ui');
        scheduler.mark('canvas');
        scheduler.mark('sticky');
        scheduler.mark('pricing');
    }

    function setActiveView(view) {
        state.activeView = (view === 'back') ? 'back' : 'front';
        scheduler.mark('canvas');
    }

    function clearAll() {
        state.acceptedItems = [];
        state.baseItem = null;
        state.proceededToStep2 = false;
        state.userInteractedOptions.clear();
        state.suggestionQueue = [];
        state.suggestionIndex = 0;
        state.maxVisitedIndex = 0;
        state.pendingSuggestion = null;
        window.acceptedItems = state.acceptedItems;
        window.baseItem = state.baseItem;
        bus.emit('acceptedItemsChanged');
        bus.emit('baseItemChanged');
        document.documentElement.removeAttribute('data-agb-step2');
    }

    // Utility functions
    function hasAccepted(handle) {
        return Array.isArray(state.acceptedItems) &&
            state.acceptedItems.some(i => i.handle === handle);
    }

    function getAcceptedIndex(handle) {
        if (!Array.isArray(state.acceptedItems)) return -1;
        return state.acceptedItems.findIndex(i => i.handle === handle);
    }

    function depsSatisfied(handle) {
        // Dynamic (product-metafield) deps are STORE-NATIVE — no remap — and take
        // precedence over the hardcoded fallback for that accessory when present.
        if (_dynamicDeps && Object.prototype.hasOwnProperty.call(_dynamicDeps, handle)) {
            const dynReq = _dynamicDeps[handle];
            if (Array.isArray(dynReq) && dynReq.length
                && !dynReq.every(parent => typeof parent === 'string' && hasAccepted(parent))) {
                return false;
            }
        } else {
            // Hardcoded fallback: map handle to US handle, then map dependencies back.
            const usHandle = StoreConfig.reverseMapHandle(handle);
            const req = SUGGESTION_DEPENDENCIES_US[usHandle] || SUGGESTION_DEPENDENCIES[handle];

            if (Array.isArray(req) && req.length) {
                // Map dependency handles and check if accepted
                const mappedDeps = StoreConfig.mapHandles(req);
                const ok = mappedDeps.every(parent => typeof parent === 'string' && hasAccepted(parent));
                if (!ok) return false;
            } else if (typeof req === 'string') {
                const mappedDep = StoreConfig.mapHandle(req);
                if (!hasAccepted(mappedDep)) return false;
            }
        }

        const guard = SUGGESTION_GUARDS[handle];
        if (typeof guard === 'function') {
            const shouldBlock = !!guard({ state, base: state.baseItem, product: state.product });
            if (shouldBlock) return false;
        }

        return true;
    }

    function countAcceptedQty(handle) {
        if (!Array.isArray(state.acceptedItems)) return 0;
        return state.acceptedItems.reduce((sum, it) =>
            sum + (it.handle === handle ? Number(it.qty || 1) : 0), 0);
    }

    // Timer management
    function addTimer(timerId) {
        state.timers.add(timerId);
        return timerId;
    }

    function addEventCleanup(cleanupFn) {
        state.eventListeners.add(cleanupFn);
        return cleanupFn;
    }

    function cleanup() {
        // Clear all timeouts and intervals
        state.timers.forEach(timer => {
            clearTimeout(timer);
            clearInterval(timer);
        });
        state.timers.clear();

        // Remove event listeners
        state.eventListeners.forEach(cleanupFn => {
            ErrorHandler.safeSync(cleanupFn, null, 'event listener cleanup');
        });
        state.eventListeners.clear();

        // Clear specific timeouts
        if (state.resolveVariantTimeout) {
            clearTimeout(state.resolveVariantTimeout);
            state.resolveVariantTimeout = null;
        }

        // Cleanup completed
    }

    // Generic mutate function for complex operations
    function mutate(fn) {
        try {
            fn(state);
            // Auto-emit common events based on what changed
            // (Could be made smarter with Proxy tracking)
            scheduler.mark('ui');
        } catch (e) {
            // Silently fail in production
        }
    }

    function setBuilderStage(stage) {
        // Builder stage set
        state.builderStage = stage;
        scheduler.mark('ui');
        scheduler.mark('canvas');
        scheduler.mark('sticky');
        scheduler.mark('pricing');
    }

    // Event subscription helpers
    function on(event, callback) {
        return bus.on(event, callback);
    }

    function emit(event, detail) {
        bus.emit(event, detail);
    }

    // Store module ready

    return {
        // State access
        getState,

        // Builder stage
        setBuilderStage,

        // Specific mutations
        setBaseItem,
        addAcceptedItem,
        removeAcceptedItem,
        setActiveView,
        clearAll,

        // Generic mutation
        mutate,

        // Utilities
        hasAccepted,
        getAcceptedIndex,
        depsSatisfied,
        countAcceptedQty,

        // Timer management
        addTimer,
        addEventCleanup,
        cleanup,

        // Events
        on,
        emit,

        // Constants (exposed for other modules)
        SUGGESTION_DEPENDENCIES,
        SUGGESTION_GUARDS,
        CO_ACTIVATE,
        dependentsMap,
        COLOR_FALLBACK_MAP
    };
});